import React, { useState } from "react";
import { Sheet } from "react-modal-sheet";
import "./sortableTariffs.css";
import Btn from "../Btn/Btn";

const SortableTariffs = ({ isOpen, onClose, onSortChange, currentSort }) => {
  const [selectedSort, setSelectedSort] = useState(currentSort);

  const handleApply = () => {
    onSortChange(selectedSort);
    onClose();
  };

  const handleBackdropClick = () => {
    if (selectedSort) {
      handleApply();
    } else {
      onClose();
    }
  };

  return (
    <Sheet isOpen={isOpen} onClose={onClose}>
      <Sheet.Container className="sort-panel">
        <Sheet.Content>
          <div className="sort-options">
            <div className="sort-header">
              <h3 className="sort-title heading-H5">Сортировка</h3>
              <button className="close-button" onClick={onClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 6L6 18M18 18L6 6"
                    stroke="#C4CADA"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            <div
              className={`sort-option ${
                selectedSort === "price-desc" ? "active" : ""
              }`}
              onClick={() => setSelectedSort("price-desc")}
            >
              <span>Цена</span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Icon"
                  d="M1.125 4.66667L5.5 0.5M5.5 0.5L9.875 4.66667M5.5 0.5L5.5 10.5"
                  stroke="#484848"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div
              className={`sort-option ${
                selectedSort === "price-asc" ? "active" : ""
              }`}
              onClick={() => setSelectedSort("price-asc")}
            >
              <span>Цена</span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Icon"
                  d="M9.875 6.33333L5.5 10.5M5.5 10.5L1.125 6.33333M5.5 10.5L5.5 0.5"
                  stroke="#484848"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div
              className={`sort-option ${
                selectedSort === "time-desc" ? "active" : ""
              }`}
              onClick={() => setSelectedSort("time-desc")}
            >
              <span>Срок</span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Icon"
                  d="M1.125 4.66667L5.5 0.5M5.5 0.5L9.875 4.66667M5.5 0.5L5.5 10.5"
                  stroke="#484848"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div
              className={`sort-option ${
                selectedSort === "time-asc" ? "active" : ""
              }`}
              onClick={() => setSelectedSort("time-asc")}
            >
              <span>Срок</span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Icon"
                  d="M9.875 6.33333L5.5 10.5M5.5 10.5L1.125 6.33333M5.5 10.5L5.5 0.5"
                  stroke="#484848"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="btn-wrapper">
            <Btn onClick={handleApply} text="Применить" width="21.375rem" />
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onClick={handleBackdropClick} />
    </Sheet>
  );
};

export default SortableTariffs;
